import "./chatroom.css";
import Chat from "./chat";
import { initializeApp } from "firebase/app";
import generateUniqueId from "../utils/generateId";

import Chatuser from "./chatuser";
import React, { useRef, useState, useEffect } from "react";
import { getDoc, doc, onSnapshot } from "firebase/firestore";
import Orderchoose from "./chatbot/queries/OrderChoose";
import ProductsDisplay from "./chatbot/queries/ProductDisplay";
import ScrollableImageGallery from "./chatbot/queries/ScrollableImageGallery";
import UploadImage from "./chatbot/queries/Upload_Image";
import { db } from "../config/firebase";
import Loader from "../component/shared/Loader";
import { getAuth } from "firebase/auth";
import DefaultMessages from "./chatbot/queries/DefaultMessages";
import { getCookie, setCookie } from "../utils/local_storing";

function Chatroom(props) {
  const { currentUser } = getAuth();
  const [localdata, setlocaldata] = useState("");
  const [messages, setMessages] = useState(
    props.sharedData != [] ? props.sharedData : []
  );
   const [currentDomainuid, setcurrentDomainUid] = useState(props.userId || null);
  const [docid, setDocid] = useState("");

  const isLoading = props.isLoading;
  const setIsLoading = props.setIsLoading; 
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [isNearBottom, setIsNearBottom] = useState(true);
  const [hasNewMessages, setHasNewMessages] = useState(false);
  const [previousMessageCount, setPreviousMessageCount] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);
  const [lastUserMessagePosition, setLastUserMessagePosition] = useState(null);

  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const handleRefreshClick = () => {
    setShowRefreshModal(true);
  };

  const handleRefreshConfirm = () => {
    // console.log("Refresh confirmed");
    
    // Clear localStorage and cookies
   
    const urlParams = new URLSearchParams(window.location.search);
        const context = urlParams.get("context");
    const shopifyContext = context ? JSON.parse(atob(context)) : null;
    const productNameFromContext = shopifyContext?.productName || null;
      const exactUrl = urlParams.get("currentUrl");
      if (exactUrl && exactUrl.includes("/products/")) {
      const productName = exactUrl.split("/products/")[1].split(/[&?]/)[0];
      setlocaldata(`Hello, I can tell you all about **${productNameFromContext}**? Let me know if you want to know more about it.`);
    
    } else {
      setlocaldata("Hello, how can I help you?");
    }
    const currentDomain = urlParams.get("parentUrl") || "null";
    var keys1="shopify_"+currentDomain+"uid"
    var keys2="shopify_"+currentDomain+"myData"
    // console.log("this is currentdomain",currentDomain)
    localStorage.removeItem(keys1);
  localStorage.removeItem(keys2);
  // console.log(localStorage)
    // Clear domain-specific cookies
    const required_name = currentDomain + "uid";
    const local_data_name = currentDomain + "myData";
    
    // Clear cookies by setting expiration date in the past
    document.cookie = `${required_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${local_data_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    
    const defaultMessage = {
      server: true,
      text: localdata,
      time: new Date().toLocaleString(),
      photoURL: null,
      timestamp: Date.now(),
    };
    
    // Reset chat state instead of reloading the page
    setMessages([defaultMessage]);
    setcurrentDomainUid(null);
    setDocid("");
    setIsInitialized(false);
    setPreviousMessageCount(0);
    setHasNewMessages(false);
    setIsNearBottom(true);
    setLastUserMessagePosition(null);
    setIsLoading(false)
    
    // Close modal
    setShowRefreshModal(false);
    
    // Trigger re-initialization of the chat
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  };

  const handleRefreshCancel = () => {
    setShowRefreshModal(false);
  };

  useEffect(() => {
    if (props.onRefreshHandler) {
      props.onRefreshHandler(handleRefreshClick);
    }
  }, [props.onRefreshHandler]);
  // State for smart scrolling
  

  // Default threshold for considering user "near bottom" (in pixels)
  const USER_MESSAGE_THRESHOLD = 150;

  // Check if user can see their last message
  const checkIfNearBottom = () => {
    if (!chatContainerRef.current) return true;
    
    if (lastUserMessagePosition !== null) {
      const { scrollTop, clientHeight } = chatContainerRef.current;
      const currentViewBottom = scrollTop + clientHeight;
      
      // Check if user has scrolled to see their last message
      return currentViewBottom >= lastUserMessagePosition;
    }
    
    // Fallback to original logic if no user message position
    const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
    return distanceFromBottom <= USER_MESSAGE_THRESHOLD;
  };

  // Handle scroll events
  const handleScroll = () => {
    const nearBottom = checkIfNearBottom();
    setIsNearBottom(nearBottom);
    
    // If user scrolled to bottom, clear new message indicator
    if (nearBottom && hasNewMessages) {
      setHasNewMessages(false);
    }
  };

  // Smooth scroll to bottom
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      setHasNewMessages(false);
      setIsNearBottom(true);
    }
  };

  // Find and store the position of the last user message
  const updateLastUserMessagePosition = () => {
    if (!Array.isArray(messages) || messages.length === 0) return;
    
    // Find the last user message
    for (let i = messages.length - 1; i >= 0; i--) {
      if (!messages[i].server) {
        // Get the position of this message element
        setTimeout(() => {
          const messageElements = chatContainerRef.current?.children;
          if (messageElements && messageElements[i]) {
            const rect = messageElements[i].getBoundingClientRect();
            const containerRect = chatContainerRef.current.getBoundingClientRect();
            const relativeTop = rect.top - containerRect.top + chatContainerRef.current.scrollTop;
            setLastUserMessagePosition(relativeTop);
          }
        }, 100);
        break;
      }
    }
  };

  // Smart scroll effect - only scroll if user is near bottom
  useEffect(() => {
    // Only start checking for new messages after initial load
    if (!isInitialized) return;
    
    // Check if we have new messages and messages is a valid array
    if (Array.isArray(messages) && messages.length > previousMessageCount && previousMessageCount > 0) {
      // Check if the new messages contain any server messages
      const newMessages = messages.slice(previousMessageCount);
      const hasNewServerMessages = newMessages.some(message => message.server === true);
      
      // Update the position of the last user message
      updateLastUserMessagePosition();
      
      if (isNearBottom) {
        // User is near bottom, auto-scroll
        setTimeout(() => {
          if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        // User is scrolled up, only show new message indicator for server messages
        if (hasNewServerMessages) {
          setHasNewMessages(true);
        }
      }
    }
    
    setPreviousMessageCount(Array.isArray(messages) ? messages.length : 0);
  }, [messages, isNearBottom, isInitialized]);

  // Initial scroll to bottom when chat first loads
  useEffect(() => {
    if (Array.isArray(messages) && messages.length > 0 && !isInitialized) {
      setTimeout(() => {
        if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView({ behavior: 'auto' });
        }
        setIsInitialized(true);
        setPreviousMessageCount(messages.length);
      }, 200);
    }
  }, [messages, isInitialized]);
  
  // Add state for docid
  
  const urlParams = new URLSearchParams(window.location.search);
  const currentDomain = urlParams.get("parentUrl") || "null";
  const shopId = currentDomain;
 const  context= urlParams.get("context")
  // btoa(JSON.stringify(shopifyContext)),
  // my shopify context is passed as above now i want to get the value of field productName
  const  shopifyContext= context ? JSON.parse(atob(context)) : null;
  // console.log("this is shopifyContext",shopifyContext)
  const productNameFromContext = shopifyContext?.productName || null;
useEffect(() => {
  //console.log("Chatroom mounted, currentDomain:", currentDomain);
  
  const required_name = currentDomain + "uid";
  const existingUid = getCookie(required_name);
  
  let currentUid;
  if (!existingUid) {
    const newUid = generateUniqueId();
    setCookie(required_name, newUid);
    setcurrentDomainUid(newUid);
    currentUid = newUid;
  } else {
    setcurrentDomainUid(existingUid);
    currentUid = existingUid;
  }
  
  const local_data_name = currentDomain + "myData";
  const storedData = getCookie(local_data_name);
  
  let currentDocid;
  if (!storedData) {
    const initialData = { key: currentUid + Date.now().toString() };
    setCookie(local_data_name, JSON.stringify(initialData));
    currentDocid = initialData.key;
  } else {
    const parsedData = JSON.parse(storedData);
    currentDocid = parsedData.key;
    //console.log("key found=", currentDocid);
  }

  // console.log("this is Docid",docid)
  
  setDocid(currentDocid);
  //console.log(currentDocid);
}, [currentDomain, currentDomainuid]);

// Simplified transformation function
const transformMessage = (item, photoURL) => {
  const baseProps = {
    photoURL,
    timestamp: Date.now(),
    mediatype: item.mediatype || 'text'
  };

  // Handle server messages
  if (item.server !== undefined) {
    if (item.action !== undefined) {
      // Action message - return user message + action + server response
      return [
        {
          server: true,
          text: item.server,
          time: item.server_timestamp,
          ...baseProps
        }
      ];
    } else {
      // Regular server message - return user message + server response
      return [
        {
          server: true,
          text: item.server,
          time: item.server_timestamp,
          ...baseProps
        }
      ];
    }
  }
  
  // Handle user-only messages
  if (item.user !== undefined) {
    return [{
      server: false,
      text: item.user,
      time: item.user_timestamp,
      ...baseProps
    }];
  }
  
  // Handle product messages
  if (item.Product) {
    return [{
      server: true,
      Product: true,
      value: item.AllProducts,
      text: item.server,
      time: item.server_timestamp,
      iShown: item.Selected_Item,
      ...baseProps
    }];
  }

  if(item.Images){
    return [
      {
      server: true,
      Images: true,
      value: item.AllImages,
      text: item.server,
      time: item.server_timestamp,
    
      ...baseProps
    }
    ]
  }

  if(item.Upload_Image){
    if(item.image_url){
 return [
        {
          server: true,
          text: item.Upload_text,
          time: item.server_timestamp,
          ...baseProps
        }
      ];
    }else{
  return [
      {
        server:true,
        Upload:true,
        text :item.Upload_text,
        url:item.image_url
      }
    ]
    }
  
  }
  return [];
};

// Separate useEffect for data fetching
useEffect(() => {
  if (!docid) return;

  const fetchData = async () => {
    const docRef = doc(db, "Messages", docid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const docmessage = docSnap.data().Messages;
      const photoURL = docSnap.data().photoURL;
      
      const transformedData = docmessage.flatMap(item => 
        transformMessage(item, photoURL)
      );
      
      setMessages(transformedData);
    } else{
        const exactUrl = urlParams.get("currentUrl");
        let serverMessage = "Hello, how can I help you?";
      if (exactUrl && exactUrl.includes("/products/")) {    
        //  let productName = exactUrl.split("/products/")[1].split(/[&?]/)[0];
        //   productName=productName.replace(/-/g, ' ');

          // const productName = document.querySelector('.product__title')?.textContent;
       

      setlocaldata(`Hello, I can tell you all about ${productNameFromContext}? Let me know if you want to know more about it.`);
    serverMessage=`Hello, I can tell you all about ${productNameFromContext}? Let me know if you want to know more about it.`;
    } else {
      setlocaldata("Hello, how can I help you?");
    }
      const defaultMessage = [
        {
          server: true,
          text: serverMessage,
          
     
        }
      ]
      setMessages(defaultMessage);
    }
  };

  fetchData();
  
  const docRef = doc(db, "Messages", docid);
  const unsubscribe = onSnapshot(docRef, (docSnap) => {
    if (docSnap.exists()) {
      const data = docSnap.data();
      if (data && data.Messages) {
        const docmessage = data.Messages;
        const photoURL = data.photoURL;
        
        const transformedData = docmessage.flatMap(item => 
          transformMessage(item, photoURL)
        );
        
        setMessages(transformedData);
      }
    } else {
      //console.log("Document does not exist");
    }
  });

  return () => unsubscribe();
}, [docid]);

// Modified display function with isLoading parameter
function chatdisplay(value, index, isLoading,setIsLoading) {
  // Handle image messages
  if (value.image) {
    return <Chat key={index} message={value} time={value.time} mediatype={value.mediatype} isLoading={isLoading} />;
  }
  
  // Handle server messages
  if (value.server) {
    if (value.Product) {
      if (value.text) {
        if (value.iShown === undefined) {
          return (
            <React.Fragment key={index}>
              <ProductsDisplay selectedProducts={value.value} subMenu={props.subMenu} selectionDisable={false} isLoading={isLoading} setIsLoading={setIsLoading}  />
              <Chat message={value} time={value.time} mediatype={value.mediatype} isLoading={isLoading} />
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={index}>
              <Chat message={value} time={value.time}  mediatype={value.mediatype} isLoading={isLoading} />
              <ProductsDisplay selectedProducts={value.value} subMenu={props.subMenu} selectionDisable={false} isLoading={isLoading} setIsLoading={setIsLoading}/>
            </React.Fragment>
          );
        }
      } else {
        return <ProductsDisplay key={index} selectedProducts={value.value} subMenu={props.subMenu} selectionDisable={false} isLoading={isLoading} setIsLoading={setIsLoading}/>;
      }
    }
    if(value.Images){
      
return   <ScrollableImageGallery images={value.value} />
       
    }
    if(value.Upload){
      return <UploadImage/>
    }
  
    
    return <Chat key={index} message={value} time={value.time} mediatype={value.mediatype} isLoading={isLoading} />;
  }
  
  // Handle user messages
  if (value.Order) {
    return (
      <React.Fragment key={index}>
        <Chatuser message={value} time={value.time} isLoading={isLoading} />
        <Orderchoose isLoading={isLoading} />
      </React.Fragment>
    );
  }
  
  if (value.Product) {
    return <ProductsDisplay key={index} selectedProducts={value.value} subMenu={props.subMenu} selectionDisable={false} isLoading={isLoading} setIsLoading={setIsLoading}/>;
  }
  
  return <Chatuser key={index} message={value} time={value.time} isLoading={isLoading} />;
}

// Check if there are any user messages in the chat
const hasUserMessages = Array.isArray(messages) && messages.some(message => {
  // Check if the message would render a Chatuser component
  return !message.server || message.Order;
});
// console.log("hasUserMessages", hasUserMessages);

// Check if actionButtons prop exists and is not empty
const hasActionButtons = props.actionButtons 
  && typeof props.actionButtons === "object" 
  && Object.keys(props.actionButtons).length > 0;

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
    <div className="krunk-py-0" style={{
      width: '100%',
      height: '100%',
      position: 'relative',
      overflowX: 'hidden',
      overflowY: 'auto',
      scrollbarWidth: 'none', // Firefox
      msOverflowStyle: 'none', // IE 10+
    }}
    ref={chatContainerRef}
    onScroll={handleScroll}
    >
      {Array.isArray(messages) && messages.map((message, index) => {
        return (
          <React.Fragment key={index}>
            {chatdisplay(message, index, isLoading, setIsLoading)}
          </React.Fragment>
        );
      })}
      {isLoading && (
        <div className="krunk-mr-2 flex justify-start mb-4">
          <Loader />
        </div>
      )}
      
      {/* Show default messages when there are no user messages OR when actionButtons is not empty */}
      {(!hasUserMessages && hasActionButtons) && <DefaultMessages isLoading={isLoading} setIsLoading={setIsLoading} actionButtons={props.actionButtons}/>}
      
      {/* New Messages Indicator */}
      {(hasNewMessages && !isNearBottom) && (
        <div 
          style={{
            position: 'sticky',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            color: 'black',
            padding: '8px 16px',
            borderRadius: '20px',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            border: '1px solid #e0e0e0',
            fontSize: '14px',
            fontWeight: '400',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            width: 'fit-content',
            margin: '0 auto'
          }}
          onClick={scrollToBottom}
        >
          New messages
          <span style={{ fontSize: '16px' }}>↓</span>
        </div>
      )}
      
      <div ref={messagesEndRef} />
      </div>
      {showRefreshModal && (
  <div style={{
    position: 'absolute',  // Changed from 'absolute' to 'fixed'
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
  }}>
    <div style={{
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
      maxWidth: '280px',
      width: '85%',
      margin: '20px',
    }}>
      <h3 style={{
        margin: '0 0 12px 0',
        fontSize: '16px',
        fontWeight: '600',
        color: '#333',
        textAlign: 'center',
      }}>
        Refresh Chat
      </h3>
      
      <p style={{
        margin: '0 0 20px 0',
        fontSize: '13px',
        color: '#666',
        textAlign: 'center',
        lineHeight: '1.4',
      }}>
        You will lose all your current chat. Do you want to refresh?
      </p>
      
      <div style={{
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
      }}>
        <button
          onClick={handleRefreshCancel}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            border: '1px solid #d1d5db',
            backgroundColor: 'white',
            color: '#374151',
            fontSize: '13px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f9fafb';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'white';
          }}
        >
          No
        </button>
        
        <button
          onClick={handleRefreshConfirm}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: 'var(--color-buttonbackground)',
            color: 'white',
            fontSize: '13px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'var(--color-buttonbackground)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'var(--color-buttonbackground)';
          }}
        >
          Yes
        </button>
      </div>
    </div>
  </div>
)}
    
    </div>
  );
}

export default Chatroom;




